import {
	ADD_IMAGES,
	RESET_IMAGES,
	ADD_TEMP_IMAGES,
	REMOVE_TEMP_IMAGES,
	UPDATE_TEMP_IMAGE,
	UPDATE_IMAGE
} from "../constants"

const initialState = {
	items: [],
	tempItems: [],
};

export const ImagesReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_IMAGES :

			action.payload.images.forEach( ( image ) => {
				const index = state.items.findIndex( el => image.key === el.key );

				if ( -1 === index ) {
					state = {
						...state,
						items: [
							...state.items,
							image
						]
					};
				}
			});


			break;
		case UPDATE_IMAGE :
			state = {
				...state,
				items: [
					...state.items.map((item, index) => {
						if ( item.key !== action.payload.image.key ) {
							return item;
						}

						return {
							...item,
							thumbPath: action.payload.image.thumbPath
						};
					})
				]
			};
			break;
		case RESET_IMAGES :
			state = {
				...state,
				items: []
			};
			break;
		case ADD_TEMP_IMAGES :
			state = {
				...state,
				tempItems: [
					...state.tempItems,
					{
						id: action.payload.id
					}
				]
			};
			break;
		case UPDATE_TEMP_IMAGE :
			state = {
				...state,
				tempItems: [
					...state.tempItems.map((item, index) => {
						if ( item.id !== action.payload.id ) {
							return item;
						}

						return {
							...item,
							progress: action.payload.progress
						}
					})
				]
			};
			break;
		case REMOVE_TEMP_IMAGES :
			state = {
				...state,
				tempItems: state.tempItems.filter( item => item.id !== action.payload.id )
			};

			// state = state.tempItems.filter( ( tempItem ) => {
			// 	console.log( tempItem.id, action.payload.id );
			// 	return tempItem.id !== action.payload.id
			// } );
			//
			// console.log( state );
			break;
		default:

			break;

	}

	return state;
};


// WEBPACK FOOTER //
// ./src/reducers/images.js